import { Component } from "solid-js";

export const LanguageBadge: Component<{ label: string; title?: string }> = (
  props
) => (
  <span
    class="px-2 py-[2px] text-[11px] rounded-full bg-slate-100 text-slate-700 border border-slate-300"
    title={props.title || props.label}
  >
    {props.label}
  </span>
);
